import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { await1uwe8zvsjq69o as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import {
  ID3j2ictjlq95nd as ID,
  CareProgramTemplatemobjbqq2s74k as CareProgramTemplate,
  CareProgramTemplateDated1lvcdu3xhc5up as CareProgramTemplateDated,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/careRates.mjs';
import { ModificationBuilder10ot0rvxki4iq as ModificationBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ModificationBuilder.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_shortNameii4jpwm36hhh as get_shortName,
  get_ageStart2z6gzlaamhsp as get_ageStart,
  get_ageEndInclusive1cq80r5bv8q1x as get_ageEndInclusive,
  get_availableAsIntermittent2wvvnkqvc4qfv as get_availableAsIntermittent,
  get_templateerawh75uwil7 as get_template,
  get_activeRanget5bqi8ppra1m as get_activeRange,
  get_start30tbw38mnjak0 as get_start,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { get_pageNavigatorp3to6r4j8ctv as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { NewCareProgramTemplateDatedPage862e666vii05 as NewCareProgramTemplateDatedPage } from './NewCareRateTemplateDatedPage.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
  get_scrolling3fwkltztkpfe8 as get_scrolling,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  get_centered31th09q7x90sf as get_centered,
  get_atEnd34105oxxaxc2o as get_atEnd,
  get_atBottomStart1iulwjfo1udg3 as get_atBottomStart,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import { renderToString1uchiuvkjsib7 as renderToString } from '../../utils/daterender.mjs';
import { Cents__toString$default_impl_dffhixgwhghxlriorf as Cents__toString$default_impl_dffhix } from '../../../../../../service-abstractions-currency/com/lightningkite/services/data/Cents.mjs';
import {
  keyValue1ck7xpd7fxylw as keyValue,
  maxWidth22r11xnm7d4h4 as maxWidth,
  goBackButton1g9k0xsmfm57i as goBackButton,
  labeledCheckbox2i8m4uxe4r9p8 as labeledCheckbox,
  addButton16duilic9iyqp as addButton,
} from '../components/view-utilities.mjs';
import { dialog3sxbjr735jrum as dialog } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { eq353yrgcpovoi1 as eq } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { SortBuilder36qqny2jtmmgx as SortBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SortBuilder.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { today1rno4frfjp5oe as today } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/clock.mjs';
import { Draftj5auffrm1u2b as Draft } from '../../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import {
  LabeledViewseav57tyecmf as LabeledView,
  LabelGapSemantic_getInstance2wftjv243mafi as LabelGapSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import {
  LabeledView$_get_content_$ref_5yojet1mvh3jfqyuzca as LabeledView$_get_content_$ref_5yojet,
  LabeledView$_set_content_$ref_ys1c8fi8j7ehqqddvg as LabeledView$_set_content_$ref_ys1c8f,
} from '../LoginScreen.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { lensPath3fz41zcs9wh0z as lensPath } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import { Dimensions32ju1l7z4mh as Dimension } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { ageRangeFieldsprqneuhkkp7o as ageRangeFields } from './rateComponents.mjs';
import {
  Button$_get_enabled_$ref_61t7nx58ibx9ifxb3n as Button$_get_enabled_$ref_61t7nx,
  Button$_set_enabled_$ref_o8kynzfmpduwei6tot as Button$_set_enabled_$ref_o8kynz,
} from '../applications/FamilyApplicationDetailPage.mjs';
import { get_waitForNotNull1jl9mx6el51tq as get_waitForNotNull } from '../../../../../../reactive/com/lightningkite/reactive/extensions/WaitForNotNull.mjs';
import {
  styledHeaderwng1nfqibdig as styledHeader,
  ChipSemantic_getInstancen74y1gyt9zmo as ChipSemantic_getInstance,
} from '../../theme/semantics.mjs';
import {
  Companion_instance35wmauq2koet0 as Companion_instance_0,
  tablezpetcq9vbay1 as table,
} from '../components/table.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function CareProgramTemplateDetailPage$render$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateShortNameLabel_odyqae_k$();
}
function CareProgramTemplateDetailPage$render$lambda_0($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateCareTimeLabel_lijrzh_k$();
}
function CareProgramTemplateDetailPage$render$lambda_1($this$labeledCheckbox) {
  return $this$labeledCheckbox.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateAvailableAsIntermittentLabel_h1v0mn_k$();
}
function CareProgramTemplateDetailPage$render$lambda_2($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudSaveButton_lsaoza_k$();
}
function CareProgramTemplateDetailPage$render$slambda(this$0) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var saved = yield* this$0.editable_1.publish_xq9q2e_k$($completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var tmp = (yield* await_0(this_0, $completion)).get_careProgramTemplates_ojj53j_k$().get_6ueaa7_k$(new (ID())(this$0.id_1));
    // Inline function 'com.lightningkite.services.database.modification' call
    // Inline function 'kotlin.apply' call
    var this_1 = new (ModificationBuilder())();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(CareProgramTemplate()), arrayOf([]), false));
    var tmp$ret$5 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$5);
    this_1.assign_vtsfu6_k$(get_shortName(it), saved.shortName_1);
    this_1.assign_vtsfu6_k$(get_ageStart(it), saved.ageStart_1);
    this_1.assign_vtsfu6_k$(get_ageEndInclusive(it), saved.ageEndInclusive_1);
    this_1.assign_vtsfu6_k$(get_availableAsIntermittent(it), saved.availableAsIntermittent_1);
    var tmp$ret$1 = this_1.build_1k0s4u_k$();
    yield* tmp.modify_ff53f_k$(tmp$ret$1, $completion);
    return Unit_instance;
  }), 1);
}
function CareProgramTemplateDetailPage$render$lambda_3($this$styledHeader) {
  return $this$styledHeader.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateCurrentRateHeading_hraq4y_k$();
}
function CareProgramTemplateDetailPage$render$lambda_4($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_ratePlanCurrentRateSubtext_41xbk6_k$();
}
function CareProgramTemplateDetailPage$render$lambda_5($this$addButton) {
  return $this$addButton.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateAddVersionButton_8qx842_k$();
}
function CareProgramTemplateDetailPage$render$lambda$slambda($this_addButton, this$0) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    get_pageNavigator($this_addButton.get_context_h02k06_k$()).navigate_sm5lxf_k$(new (NewCareProgramTemplateDatedPage())(this$0.id_1));
    return Unit_instance;
  }), 1);
}
function CareProgramTemplateDetailPage$render$lambda_6($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateCurrentChip_ej3r0k_k$();
}
function CareProgramTemplateDetailPage$render$lambda_7($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateDailyRateColumnLabel_3eflwu_k$();
}
function CareProgramTemplateDetailPage$render$lambda_8($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateTransportOneWayLabel_hbgejv_k$();
}
function CareProgramTemplateDetailPage$render$lambda_9($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateTransportTwoWayLabel_x99pbj_k$();
}
function CareProgramTemplateDetailPage$render$lambda_10($this$styledHeader) {
  return $this$styledHeader.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateVersionHistoryHeading_go8cgt_k$();
}
function CareProgramTemplateDetailPage$render$lambda_11($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateVersionHistorySubtext_rd6t14_k$();
}
function CareProgramTemplateDetailPage$render$lambda_12($this$table, current) {
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Button())($this$table.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $this$table.willAddChild_hz2iwc_k$(element);
  element.set_action_2ds022_k$(Action('Detail', VOID, VOID, VOID, VOID, VOID, CareProgramTemplateDetailPage$render$lambda$slambda_0(element, current)));
  element.onStartup_vrxh3i_k$();
  $this$table.addChild_2qpft2_k$(element);
  return element;
}
function CareProgramTemplateDetailPage$render$lambda$slambda$lambda$lambda($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateDailyRateColumnLabel_3eflwu_k$();
}
function CareProgramTemplateDetailPage$render$lambda$slambda$lambda$lambda_0($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateTransportOneWayLabel_hbgejv_k$();
}
function CareProgramTemplateDetailPage$render$lambda$slambda$lambda$lambda_1($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateTransportTwoWayLabel_x99pbj_k$();
}
function CareProgramTemplateDetailPage$render$lambda$slambda_0($$this$button, $current) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp = $$this$button.get_context_h02k06_k$();
    dialog(tmp, VOID, ($this$dialog, it) => {
      // Inline function 'com.lightningkite.kiteui.views.card' call
      var this_0 = sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_rem(50));
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      var this_1 = themed(this_0, CardSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
      ensureOutermostElement(element);
      this_1.willAddChild_hz2iwc_k$(element);
      element.set_vertical_nuap32_k$(true);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_0);
      element.willAddChild_hz2iwc_k$(element_0);
      element_0.set_vertical_nuap32_k$(false);
      // Inline function 'com.lightningkite.kiteui.views.expanding' call
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      var this_2 = weight(element_0, 1.0);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_1 = new (Space())(this_2.get_context_h02k06_k$());
      ensureOutermostElement(element_1);
      this_2.willAddChild_hz2iwc_k$(element_1);
      element_1.onStartup_vrxh3i_k$();
      this_2.addChild_2qpft2_k$(element_1);
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      var this_3 = get_centered(element_0);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_2 = new (TextView())(this_3.get_context_h02k06_k$());
      ensureOutermostElement(element_2);
      this_3.willAddChild_hz2iwc_k$(element_2);
      var tmp = KMutableProperty0();
      var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_2);
      var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_2));
      element_2.invoke_bnq13k_k$(tmp_1, ($this$invoke) => renderToString($this$invoke, $this$invoke.invoke_r7m7el_k$($current).activeRange_1));
      element_2.onStartup_vrxh3i_k$();
      this_3.addChild_2qpft2_k$(element_2);
      element_0.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_0);
      var tmp_2 = CareProgramTemplateDetailPage$render$lambda$slambda$lambda$lambda;
      keyValue(element, tmp_2, ($this$keyValue) => Cents__toString$default_impl_dffhix($this$keyValue.invoke_r7m7el_k$($current).price_1, VOID, true));
      var tmp_3 = CareProgramTemplateDetailPage$render$lambda$slambda$lambda$lambda_0;
      keyValue(element, tmp_3, ($this$keyValue) => Cents__toString$default_impl_dffhix($this$keyValue.invoke_r7m7el_k$($current).transportOneWay_1, VOID, true));
      var tmp_4 = CareProgramTemplateDetailPage$render$lambda$slambda$lambda$lambda_1;
      keyValue(element, tmp_4, ($this$keyValue) => Cents__toString$default_impl_dffhix($this$keyValue.invoke_r7m7el_k$($current).transportTwoWay_1, VOID, true));
      element.onStartup_vrxh3i_k$();
      this_1.addChild_2qpft2_k$(element);
      return Unit_instance;
    });
    return Unit_instance;
  }), 1);
}
function CareProgramTemplateDetailPage$render$lambda_13($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateInForceColumnLabel_elll5r_k$();
}
function CareProgramTemplateDetailPage$render$lambda_14($this$text, it) {
  return it.activeRange_1.toString();
}
function CareProgramTemplateDetailPage$render$lambda_15($this$custom) {
  return $this$custom.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateDailyRateColumnLabel_3eflwu_k$();
}
function CareProgramTemplateDetailPage$render$lambda_16($this$custom, version) {
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())($this$custom.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $this$custom.willAddChild_hz2iwc_k$(element);
  element.set_wraps_9wisy1_k$(false);
  element.set_ellipsis_rhzl3b_k$(true);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
  element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => Cents__toString$default_impl_dffhix($this$invoke.invoke_r7m7el_k$(version).price_1, VOID, true));
  element.onStartup_vrxh3i_k$();
  $this$custom.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function CareProgramTemplateDetailPage$render$lambda_17($this$custom) {
  return $this$custom.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateTransportOneWayLabel_hbgejv_k$();
}
function CareProgramTemplateDetailPage$render$lambda_18($this$custom, version) {
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())($this$custom.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $this$custom.willAddChild_hz2iwc_k$(element);
  element.set_wraps_9wisy1_k$(false);
  element.set_ellipsis_rhzl3b_k$(true);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
  element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => Cents__toString$default_impl_dffhix($this$invoke.invoke_r7m7el_k$(version).transportOneWay_1, VOID, true));
  element.onStartup_vrxh3i_k$();
  $this$custom.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function CareProgramTemplateDetailPage$render$lambda_19($this$custom) {
  return $this$custom.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateTransportTwoWayLabel_x99pbj_k$();
}
function CareProgramTemplateDetailPage$render$lambda_20($this$custom, version) {
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())($this$custom.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $this$custom.willAddChild_hz2iwc_k$(element);
  element.set_wraps_9wisy1_k$(false);
  element.set_ellipsis_rhzl3b_k$(true);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
  element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => Cents__toString$default_impl_dffhix($this$invoke.invoke_r7m7el_k$(version).transportTwoWay_1, VOID, true));
  element.onStartup_vrxh3i_k$();
  $this$custom.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function CareProgramTemplateDetailPage$render$lambda_21($this$shownWhen) {
  return get_current(Companion_instance).equals(Platform_Web_getInstance());
}
var CareProgramTemplateDetailPageClass;
function CareProgramTemplateDetailPage() {
  if (CareProgramTemplateDetailPageClass === VOID) {
    class $ {
      constructor(id) {
        this.id_1 = id;
        var tmp = this;
        tmp.template_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.awaitNotNull_2lqt5h_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careProgramTemplates_ojj53j_k$().get_6ueaa7_k$(new (ID())(this.id_1))));
        var tmp_0 = this;
        tmp_0.versions_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careProgramTemplateDateds_knbayp_k$();
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(CareProgramTemplateDated()), arrayOf([]), false));
          var tmp$ret$2 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$2);
          var tmp_1 = eq(get_template(it), new (ID())($this$remember.invoke_r7m7el_k$(this.template_1)._id_1));
          // Inline function 'com.lightningkite.services.database.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_2 = serializerOrContextual(createKType(getKClass(CareProgramTemplateDated()), arrayOf([]), false));
          var tmp$ret$9 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$9);
          this_0.descending_tl4o2_k$(get_start(get_activeRange(it_0)));
          var tmp$ret$5 = this_0.build_1k0s4u_k$();
          return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(new (Query())(tmp_1, tmp$ret$5)));
        });
        var tmp_1 = this;
        tmp_1.currentVersion_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp0 = $this$remember.invoke_r7m7el_k$(this.versions_1);
          var tmp$ret$11;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
            while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
              var element = _iterator__ex2g4s.next_20eer_k$();
              if (element.activeRange_1.contains_pio7lx_k$(today())) {
                tmp$ret$11 = element;
                break $l$block;
              }
            }
            tmp$ret$11 = null;
          }
          return tmp$ret$11;
        });
        var tmp_2 = this;
        tmp_2.editable_1 = Draft(($this$Draft) => $this$Draft.invoke_r7m7el_k$(this.template_1));
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(this.template_1).name_1);
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance().fromParentNonCascading_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        goBackButton(get_centered(element_0));
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_2 = get_centered(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_3 = weight(this_2, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextView())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_3.willAddChild_hz2iwc_k$(element_1);
        element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
        element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(this.get_title_iz32un_k$()));
        element_1.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_1);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_4 = themed(element, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (RowOrCol())(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_4.willAddChild_hz2iwc_k$(element_2);
        element_2.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element_2.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        element_2.willAddChild_hz2iwc_k$(element_3);
        var tmp_2 = KMutableProperty0();
        var tmp_3 = LabeledView$_get_content_$ref_5yojet(element_3);
        var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, LabeledView$_set_content_$ref_ys1c8f(element_3));
        element_3.invoke_bnq13k_k$(tmp_4, CareProgramTemplateDetailPage$render$lambda);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        var this_5 = themed(element_3, FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (TextInput())(this_5.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        this_5.willAddChild_hz2iwc_k$(element_4);
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_6 = this.editable_1;
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_5 = serializerOrContextual(createKType(getKClass(CareProgramTemplate()), arrayOf([]), false));
        var tmp$ret$30 = isInterface(tmp_5, KSerializer()) ? tmp_5 : THROW_CCE();
        var it = new (DataClassPathSelf())(tmp$ret$30);
        var tmp$ret$31 = get_shortName(it);
        var tmp$ret$28 = lensPath(this_6, tmp$ret$31);
        element_4.bind_gesskf_k$(element_4.content_1, tmp$ret$28);
        element_4.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_4);
        element_3.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
        var breakpoint = get_rem(40);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (RowCollapsingToColumn())(element_2.get_context_h02k06_k$(), listOf(new (Dimension())(breakpoint)));
        ensureOutermostElement(element_5);
        element_2.willAddChild_hz2iwc_k$(element_5);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var tmp_6 = weight(element_5, 1.0);
        var tmp_7 = CareProgramTemplateDetailPage$render$lambda_0;
        keyValue(tmp_6, tmp_7, ($this$keyValue) => $this$keyValue.invoke_r7m7el_k$(this.template_1).careTime_1.displayName_1);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var tmp_8 = weight(element_5, 1.0);
        var tmp_9 = CareProgramTemplateDetailPage$render$lambda_1;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_7 = this.editable_1;
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_10 = serializerOrContextual(createKType(getKClass(CareProgramTemplate()), arrayOf([]), false));
        var tmp$ret$39 = isInterface(tmp_10, KSerializer()) ? tmp_10 : THROW_CCE();
        var it_0 = new (DataClassPathSelf())(tmp$ret$39);
        var tmp$ret$40 = get_availableAsIntermittent(it_0);
        var tmp$ret$37 = lensPath(this_7, tmp$ret$40);
        labeledCheckbox(tmp_8, tmp_9, tmp$ret$37);
        element_5.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_5);
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_8 = this.editable_1;
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_11 = serializerOrContextual(createKType(getKClass(CareProgramTemplate()), arrayOf([]), false));
        var tmp$ret$43 = isInterface(tmp_11, KSerializer()) ? tmp_11 : THROW_CCE();
        var it_1 = new (DataClassPathSelf())(tmp$ret$43);
        var tmp$ret$44 = get_ageStart(it_1);
        var tmp_12 = lensPath(this_8, tmp$ret$44);
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_9 = this.editable_1;
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_13 = serializerOrContextual(createKType(getKClass(CareProgramTemplate()), arrayOf([]), false));
        var tmp$ret$47 = isInterface(tmp_13, KSerializer()) ? tmp_13 : THROW_CCE();
        var it_2 = new (DataClassPathSelf())(tmp$ret$47);
        var tmp$ret$48 = get_ageEndInclusive(it_2);
        var tmp$ret$45 = lensPath(this_9, tmp$ret$48);
        ageRangeFields(element_2, tmp_12, tmp$ret$45);
        // Inline function 'com.lightningkite.kiteui.views.important' call
        var this_10 = get_atEnd(element_2);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        var this_11 = themed(this_10, ImportantSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_12 = themed(this_11, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (Button())(this_12.get_context_h02k06_k$());
        ensureOutermostElement(element_6);
        this_12.willAddChild_hz2iwc_k$(element_6);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_7 = new (TextView())(element_6.get_context_h02k06_k$());
        ensureOutermostElement(element_7);
        element_6.willAddChild_hz2iwc_k$(element_7);
        var tmp_14 = KMutableProperty0();
        var tmp_15 = TextView$_get_content_$ref_4pzcwl(element_7);
        var tmp_16 = getPropertyCallableRef('content', 0, tmp_14, tmp_15, TextView$_set_content_$ref_pketfb(element_7));
        element_7.invoke_bnq13k_k$(tmp_16, CareProgramTemplateDetailPage$render$lambda_2);
        element_7.onStartup_vrxh3i_k$();
        element_6.addChild_2qpft2_k$(element_7);
        var tmp_17 = KMutableProperty0();
        var tmp_18 = Button$_get_enabled_$ref_61t7nx(element_6);
        var tmp_19 = getPropertyCallableRef('enabled', 0, tmp_17, tmp_18, Button$_set_enabled_$ref_o8kynz(element_6));
        element_6.invoke_bnq13k_k$(tmp_19, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(this.editable_1.get_changesMade_d6j01d_k$()));
        element_6.set_action_2ds022_k$(Action('Save template', VOID, VOID, VOID, VOID, VOID, CareProgramTemplateDetailPage$render$slambda(this)));
        element_6.onStartup_vrxh3i_k$();
        this_12.addChild_2qpft2_k$(element_6);
        element_2.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_13 = shownWhen(element, VOID, VOID, ($this$shownWhen) => !($this$shownWhen.invoke_r7m7el_k$(this.currentVersion_1) == null));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_8 = new (RowOrCol())(this_13.get_context_h02k06_k$());
        ensureOutermostElement(element_8);
        this_13.willAddChild_hz2iwc_k$(element_8);
        element_8.set_vertical_nuap32_k$(true);
        var current = get_waitForNotNull(this.currentVersion_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_9 = new (RowOrCol())(element_8.get_context_h02k06_k$());
        ensureOutermostElement(element_9);
        element_8.willAddChild_hz2iwc_k$(element_9);
        element_9.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_14 = get_atBottomStart(element_9);
        var tmp$ret$65 = weight(this_14, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_15 = themed(tmp$ret$65, LabelGapSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_10 = new (RowOrCol())(this_15.get_context_h02k06_k$());
        ensureOutermostElement(element_10);
        this_15.willAddChild_hz2iwc_k$(element_10);
        element_10.set_vertical_nuap32_k$(true);
        styledHeader(element_10, CareProgramTemplateDetailPage$render$lambda_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_11 = new (TextView())(element_10.get_context_h02k06_k$());
        ensureOutermostElement(element_11);
        element_10.willAddChild_hz2iwc_k$(element_11);
        element_11.set_themeChoice_py59um_k$(element_11.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
        var tmp_20 = KMutableProperty0();
        var tmp_21 = TextView$_get_content_$ref_4pzcwl(element_11);
        var tmp_22 = getPropertyCallableRef('content', 0, tmp_20, tmp_21, TextView$_set_content_$ref_pketfb(element_11));
        element_11.invoke_bnq13k_k$(tmp_22, CareProgramTemplateDetailPage$render$lambda_4);
        element_11.onStartup_vrxh3i_k$();
        element_10.addChild_2qpft2_k$(element_11);
        element_10.onStartup_vrxh3i_k$();
        this_15.addChild_2qpft2_k$(element_10);
        // Inline function 'com.lightningkite.kiteui.views.important' call
        var this_16 = get_centered(element_9);
        var tmp_23 = themed(this_16, ImportantSemantic_getInstance());
        var tmp_24 = CareProgramTemplateDetailPage$render$lambda_5;
        addButton(tmp_23, tmp_24, ($this$addButton) => {
          $this$addButton.set_action_2ds022_k$(Action('Add version', VOID, VOID, VOID, VOID, VOID, CareProgramTemplateDetailPage$render$lambda$slambda($this$addButton, this)));
          return Unit_instance;
        });
        element_9.onStartup_vrxh3i_k$();
        element_8.addChild_2qpft2_k$(element_9);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_17 = themed(element_8, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_12 = new (RowOrCol())(this_17.get_context_h02k06_k$());
        ensureOutermostElement(element_12);
        this_17.willAddChild_hz2iwc_k$(element_12);
        element_12.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_13 = new (RowOrCol())(element_12.get_context_h02k06_k$());
        ensureOutermostElement(element_13);
        element_12.willAddChild_hz2iwc_k$(element_13);
        element_13.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.important' call
        var this_18 = themed(get_centered(element_13), ChipSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_19 = themed(this_18, ImportantSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_14 = new (TextView())(this_19.get_context_h02k06_k$());
        ensureOutermostElement(element_14);
        this_19.willAddChild_hz2iwc_k$(element_14);
        var tmp_25 = KMutableProperty0();
        var tmp_26 = TextView$_get_content_$ref_4pzcwl(element_14);
        var tmp_27 = getPropertyCallableRef('content', 0, tmp_25, tmp_26, TextView$_set_content_$ref_pketfb(element_14));
        element_14.invoke_bnq13k_k$(tmp_27, CareProgramTemplateDetailPage$render$lambda_6);
        element_14.onStartup_vrxh3i_k$();
        this_19.addChild_2qpft2_k$(element_14);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_20 = weight(element_13, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_15 = new (Space())(this_20.get_context_h02k06_k$());
        ensureOutermostElement(element_15);
        this_20.willAddChild_hz2iwc_k$(element_15);
        element_15.onStartup_vrxh3i_k$();
        this_20.addChild_2qpft2_k$(element_15);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_21 = get_centered(element_13);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_16 = new (TextView())(this_21.get_context_h02k06_k$());
        ensureOutermostElement(element_16);
        this_21.willAddChild_hz2iwc_k$(element_16);
        var tmp_28 = KMutableProperty0();
        var tmp_29 = TextView$_get_content_$ref_4pzcwl(element_16);
        var tmp_30 = getPropertyCallableRef('content', 0, tmp_28, tmp_29, TextView$_set_content_$ref_pketfb(element_16));
        element_16.invoke_bnq13k_k$(tmp_30, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).rateInForceSince_kfs6_k$($this$invoke.invoke_r7m7el_k$(current).activeRange_1.toString()));
        element_16.onStartup_vrxh3i_k$();
        this_21.addChild_2qpft2_k$(element_16);
        element_13.onStartup_vrxh3i_k$();
        element_12.addChild_2qpft2_k$(element_13);
        var tmp_31 = CareProgramTemplateDetailPage$render$lambda_7;
        keyValue(element_12, tmp_31, ($this$keyValue) => Cents__toString$default_impl_dffhix($this$keyValue.invoke_r7m7el_k$(current).price_1, VOID, true));
        var tmp_32 = CareProgramTemplateDetailPage$render$lambda_8;
        keyValue(element_12, tmp_32, ($this$keyValue) => Cents__toString$default_impl_dffhix($this$keyValue.invoke_r7m7el_k$(current).transportOneWay_1, VOID, true));
        var tmp_33 = CareProgramTemplateDetailPage$render$lambda_9;
        keyValue(element_12, tmp_33, ($this$keyValue) => Cents__toString$default_impl_dffhix($this$keyValue.invoke_r7m7el_k$(current).transportTwoWay_1, VOID, true));
        element_12.onStartup_vrxh3i_k$();
        this_17.addChild_2qpft2_k$(element_12);
        element_8.onStartup_vrxh3i_k$();
        this_13.addChild_2qpft2_k$(element_8);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_17 = new (Space())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_17);
        element.willAddChild_hz2iwc_k$(element_17);
        element_17.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_17);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_22 = themed(element, LabelGapSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_18 = new (RowOrCol())(this_22.get_context_h02k06_k$());
        ensureOutermostElement(element_18);
        this_22.willAddChild_hz2iwc_k$(element_18);
        element_18.set_vertical_nuap32_k$(true);
        styledHeader(element_18, CareProgramTemplateDetailPage$render$lambda_10);
        // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_19 = new (TextView())(element_18.get_context_h02k06_k$());
        ensureOutermostElement(element_19);
        element_18.willAddChild_hz2iwc_k$(element_19);
        element_19.set_themeChoice_py59um_k$(element_19.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
        var tmp_34 = KMutableProperty0();
        var tmp_35 = TextView$_get_content_$ref_4pzcwl(element_19);
        var tmp_36 = getPropertyCallableRef('content', 0, tmp_34, tmp_35, TextView$_set_content_$ref_pketfb(element_19));
        element_19.invoke_bnq13k_k$(tmp_36, CareProgramTemplateDetailPage$render$lambda_11);
        element_19.onStartup_vrxh3i_k$();
        element_18.addChild_2qpft2_k$(element_19);
        element_18.onStartup_vrxh3i_k$();
        this_22.addChild_2qpft2_k$(element_18);
        var tmp_37 = CareProgramTemplateDetailPage$render$lambda_12;
        var tmp_38 = Companion_instance_0;
        var tmp_39 = CareProgramTemplateDetailPage$render$lambda_13;
        var tmp_40 = tmp_38.text_y5ktm4_k$(tmp_39, 2.0, CareProgramTemplateDetailPage$render$lambda_14);
        var tmp_41 = Companion_instance_0;
        var tmp_42 = CareProgramTemplateDetailPage$render$lambda_15;
        var tmp_43 = tmp_41.custom_k0krgj_k$(tmp_42, 1.0, CareProgramTemplateDetailPage$render$lambda_16);
        var tmp_44 = Companion_instance_0;
        var tmp_45 = CareProgramTemplateDetailPage$render$lambda_17;
        var tmp_46 = tmp_44.custom_k0krgj_k$(tmp_45, 1.0, CareProgramTemplateDetailPage$render$lambda_18);
        var tmp_47 = Companion_instance_0;
        var tmp_48 = CareProgramTemplateDetailPage$render$lambda_19;
        table(element, this.versions_1, tmp_37, [tmp_40, tmp_43, tmp_46, tmp_47.custom_k0krgj_k$(tmp_48, 1.0, CareProgramTemplateDetailPage$render$lambda_20)]);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_23 = shownWhen(element, VOID, VOID, CareProgramTemplateDetailPage$render$lambda_21);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_20 = new (Space())(this_23.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_20);
        this_23.willAddChild_hz2iwc_k$(element_20);
        element_20.onStartup_vrxh3i_k$();
        this_23.addChild_2qpft2_k$(element_20);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'CareProgramTemplateDetailPage', VOID, VOID, [Page()]);
    CareProgramTemplateDetailPageClass = $;
  }
  return CareProgramTemplateDetailPageClass;
}
//region block: exports
export {
  CareProgramTemplateDetailPage as CareProgramTemplateDetailPagec1d9jyccm55e,
};
//endregion

//# sourceMappingURL=CareRateTemplateDetailPage.mjs.map
